import { render, staticRenderFns } from "./ProfileDropdown.vue?vue&type=template&id=20a7f8ec"
import script from "./ProfileDropdown.vue?vue&type=script&lang=ts"
export * from "./ProfileDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ProfileDropdown.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(component)

export default component.exports